export enum UserSessionStatus {
    NOT_READY = "NOT_READY",
    READY = "READY"
}